import React, { useEffect, useState, useContext } from "react";
import UsageBox from "./UsageBox/UsageBox";
import "./Usage.css";
import { LanguageContext } from "../../context/LanguageContext";
const Usage = () => {
  const [data, setData] = useState([]);
  const { language } = useContext(LanguageContext);

  useEffect(() => {
    if (language === "german") {
      fetch("https://swissmailsecurity.ch/wp-json/wp/v2/posts?categories=4")
        .then((res) => res.json())
        .then((res) => {
          setData(res);
        });
    } else if (language === "french") {
      fetch("https://swissmailsecurity.ch/wp-json/wp/v2/posts?categories=10")
        .then((res) => res.json())
        .then((res) => {
          setData(res);
        });
    }
  }, [language]);

  return (
    <div className="usage_container">
      <div className="usage_grid_container">
        <div className="usage_text">
          <h3>
            {language === "german"
              ? "Hier lässt sich Swiss Mail Security einsetzen"
              : "Swiss Mail Security peut être utilisé ici"}
          </h3>
        </div>
        {data.map((item, index) => {
          return (
            <div className="usage_grid_item" key={index}>
              <UsageBox
                key={index}
                data={item.content.rendered}
                title={item.title.rendered}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Usage;
